export default __webpack_public_path__ + "static/fonts/HelveticaNeue-Light.8529f65.woff";